export default __webpack_public_path__ + "static/media/arrow-left.26ed52ff.svg";